import {Component, Injector} from "@angular/core";
import {ShiftsDialogBaseComponent} from "./shifts-dialog-base/shifts-dialog-base.component";
import {ShiftsService} from "../../../services/shifts.service";

@Component({
    selector: 'app-edit-shift',
    templateUrl: './shifts-dialog-base/shifts-dialog-base.component.html',
    styleUrls: ['./shifts-dialog-base/shifts-dialog-base.component.css'],
    standalone: false
})
export class EditShiftComponent extends ShiftsDialogBaseComponent {
  private shiftsService: ShiftsService;

  constructor(protected injector: Injector) {
    super(injector);
    this.shiftsService = injector.get(ShiftsService);
    this.dialogId = "editShift";
  }

  public submit() {
    this.shiftsService.EditShift(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          this.syncService.NotifyEntityChanged("Shift",this.model.Id);
          super.submit();

        });
  }

}
